<template>
  <div id="features-one-image" class="mt-10 -mx-4 relative lg:mt-0">
    <img class="max-w-xs md:max-w-lg relative mx-auto" width="490" src="../../../assets/safe.svg" alt/>
  </div>
</template>

<script>
import {gsap} from 'gsap'
export default {
  name: "FeaturesOneSvg",
  methods: {
    animationsInit(){
      const scroller = this.$parent.$parent.$parent.$refs["scrollSections"];
      const trigger = "#features-one-image";
      gsap.to(trigger, {
        scrollTrigger: {
          trigger,
          scroller,
          start: 'top 95%',
          end: 'bottom 25%'
        },
        y: 0,
        opacity: 1,
        autoAlpha: 1,
        duration: 1
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      gsap.set('#features-one-image', {
        y: 100,
        opacity:0,
        autoAlpha: 0
      })
      this.animationsInit()
    })
  }
}
</script>

<style scoped>

</style>
